import * as Types from 'types'

import { FEATURES, isFeatureEnabled } from 'utilities/features'
import React, { Component } from 'react'
import { cardFormatMasked, cardFormatShort, priceNumberToString } from 'utilities/text'
import Button from 'components/UI/Button'
import PropTypes from 'prop-types'
import { SubText } from 'checkout'
import { capitalize } from 'utilities/text'
import { connect } from 'react-redux'
import { makeDeliveryAddress } from 'utilities/address'
import { beginCheckout, placeOrder } from 'actions/Checkout'
import { generateCVCToken } from 'actions/NewPaymentMethod'
import { push } from 'connected-react-router'
import { withTranslation } from 'react-i18next'
import { toggleCvcInput } from 'actions/UI'
import { PaymentMethodType } from 'types/paymentMethodType'
import classNames from 'classnames'
import './PlaceOrderButton.scss'
import { isValidCardNumber } from 'utilities/validators'

export class PlaceOrderButton extends Component {
    componentWillReceiveProps(nextProps) {
        if (nextProps.awaitingOrderResponse && !this.props.awaitingOrderResponse) {
            this.props.dispatch(push('/checkout/processing'))
        }
    }
    render() {
        const {
            dispatch,
            cart,
            cartTotal,
            personalInfo,
            activeAddress,
            awaitingOrderResponse,
            preferredPaymentMethod,
            deliveryDate,
            optinForNews,
            email,
            adyenCardToken,
            gift,
            transportProduct,
            onClick,
            canDeliverToAddress,
            requireCvc,
            showCvcInput,
            idPrefix,
            cartTotalIsZero,
            paymentMethodType,
            t,
        } = this.props

        const paymentMethodTypeIsCreditCard = paymentMethodType === PaymentMethodType.CREDIT_CARD

        const readyToSubmit = !paymentMethodTypeIsCreditCard || !requireCvc || showCvcInput

        const buttonIsDisabled = awaitingOrderResponse || !canDeliverToAddress

        let cannotDeliverToAddressText = t('notificationsCannotDeliverNotification1', {
            streetAddress: capitalize(activeAddress.streetName),
            city: activeAddress.city,
        })

        const buttonText = readyToSubmit
            ? cartTotalIsZero
                ? t('freeOrderButton')
                : t('placeOrderButtonWithAmount', {
                      amount: priceNumberToString(cartTotal),
                  })
            : t('askForCvcButton')

        const buttonTextLight =
            readyToSubmit && !cartTotalIsZero
                ? paymentMethodTypeIsCreditCard
                    ? preferredPaymentMethod.preferred ||
                      isValidCardNumber(preferredPaymentMethod.cardNo)
                        ? `\xa0${t('orderWithGivenCreditCard', {
                              card: cardFormatShort(
                                  cardFormatMasked(preferredPaymentMethod.cardNo)
                              ),
                          })}`
                        : null
                    : `\xa0${t('orderWithVipps')}`
                : null

        const classes = classNames({
            'place-order-button': true,
            'place-order-button--checkout': idPrefix === 'checkoutSummary',
        })

        return (
            <SubText
                value={cannotDeliverToAddressText}
                type={!canDeliverToAddress ? 'error' : null}
                centered
            >
                <Button
                    id={`${idPrefix}${readyToSubmit ? 'PlaceOrder' : 'RequireCvc'}`}
                    variant="primary"
                    disabled={buttonIsDisabled}
                    onClick={async (e) => {
                        onClick && onClick(e)

                        if (!readyToSubmit) {
                            !showCvcInput && dispatch(toggleCvcInput(true))
                            idPrefix === 'cartCheckout' && dispatch(beginCheckout())
                            return
                        }

                        let token
                        if (paymentMethodTypeIsCreditCard && requireCvc && !cartTotalIsZero) {
                            token = await dispatch(generateCVCToken())
                            if (!token) return
                        }

                        const deliveryAddress = makeDeliveryAddress(
                            activeAddress,
                            personalInfo,
                            transportProduct
                        )

                        dispatch(
                            placeOrder(
                                cart,
                                cartTotal,
                                deliveryAddress,
                                deliveryDate,
                                email,
                                token || adyenCardToken,
                                gift,
                                optinForNews,
                                personalInfo,
                                preferredPaymentMethod.paymentMethodId,
                                paymentMethodType
                            )
                        )
                    }}
                    className={classes}
                >
                    <div className="place-order-button--button-text">
                        {buttonText}
                        <div className="place-order-button--button-text--light">
                            {buttonTextLight}
                        </div>
                    </div>
                </Button>
            </SubText>
        )
    }
}

PlaceOrderButton.propTypes = {
    email: PropTypes.string,
    dispatch: PropTypes.func,
    disabled: PropTypes.bool,
    cartTotal: PropTypes.number,
    cart: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            quantity: PropTypes.number.isRequired,
        })
    ),
    personalInfo: Types.personalInfo,
    activeAddress: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        mobile: PropTypes.string,
        deliveryPointId: PropTypes.number,
        streetName: PropTypes.string,
        streetNo: PropTypes.number,
        entrance: PropTypes.string,
        floorNo: PropTypes.number,
        floorType: PropTypes.string,
        flatNo: PropTypes.number,
        zip: PropTypes.string,
        city: PropTypes.string,
        countryCode: PropTypes.string,
        deliverySms: PropTypes.bool,
    }).isRequired,
    transportProduct: PropTypes.string,
    awaitingOrderResponse: PropTypes.bool,
    preferredPaymentMethod: PropTypes.object,
    deliveryDate: PropTypes.string,
    optinForNews: PropTypes.bool,
    adyenCardToken: PropTypes.string,
    gift: Types.gift,
    canDeliverToAddress: PropTypes.bool,
    onClick: PropTypes.func,
    requireCvc: PropTypes.bool,
    showCvcInput: PropTypes.bool,
    idPrefix: PropTypes.string,
    cartTotalIsZero: PropTypes.bool,
    paymentMethodType: PropTypes.string,
    t: PropTypes.func,
}

const mapStateToProps = ({
    cart,
    checkout,
    user,
    personalInfo,
    newPaymentMethod,
    address,
    region,
    gift,
    paymentMethod,
    distribution,
    features,
    ui,
}) => {
    return {
        email: user.isLoggedIn ? user.jwtData.spidEmail : personalInfo.email,
        awaitingOrderResponse: checkout.awaitingOrderResponse,
        cart: cart.products,
        personalInfo: personalInfo,
        activeAddress: address.active,
        cartTotal: cart.total,
        deliveryDate: checkout.deliveryDate,
        optinForNews: checkout.optinForNews,
        adyenCardToken: newPaymentMethod.token,
        transportProduct: region.transportProduct,
        preferredPaymentMethod: newPaymentMethod.active
            ? newPaymentMethod
            : paymentMethod.preferred,
        gift: gift,
        canDeliverToAddress: distribution.canDeliver,
        requireCvc: !newPaymentMethod.active && isFeatureEnabled(features, FEATURES.CVC),
        showCvcInput: ui.showCvcInput,
        cartTotalIsZero: cart.total == 0,
        paymentMethodType: checkout.paymentMethodType,
    }
}

export default connect(mapStateToProps)(withTranslation()(PlaceOrderButton))
